export default __webpack_public_path__ + "static/media/CREDITCARDFAILED.3b89640e.png";